import { render, staticRenderFns } from "./MatrixConf.vue?vue&type=template&id=bd709f92"
import script from "./MatrixConf.vue?vue&type=script&lang=js"
export * from "./MatrixConf.vue?vue&type=script&lang=js"
import style0 from "./MatrixConf.vue?vue&type=style&index=0&id=bd709f92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports